import { GeneralSearchAssetsToComparisonFundsUseCase } from '@mais-retorno-front/core-business/useCases/search-asset/search-general-comparison-funds.usecase';

export const makeSearchAssetsToComparisonFunds = () => {
  return new GeneralSearchAssetsToComparisonFundsUseCase();
};
